import DOMPurify from 'dompurify'

/**
 * Sanitize HTML to prevent XSS attacks.
 * Allows safe HTML tags (from markdown rendering) but strips scripts, event handlers, etc.
 */
export const sanitizeHtml = (html) => DOMPurify.sanitize(html)

/**
 * Escape text for safe interpolation in HTML template literals.
 * Use for user-provided plain text (names, IDs) that should NOT contain HTML.
 */
export const escapeText = (text) => {
  if (text == null) return ''
  return String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}
